import popairpodscase from '../../assets/muvtech/Muvdata/AirpodCases/POPAirpodCases.png';

const airpodscaseData = [
  {
    id: 1,
    type: 'airpodscase',
    title: 'POP Series',
    compatibleModels: 'AirPods 4',
    price: 999,
    specs: ['Silicone material', 'Scratch/bump protection', 'For AirPods 4'],
    image: [popairpodscase],
  },
];

export default airpodscaseData;
